Element.prototype.remove = function() {
  this.parentElement.removeChild(this);
};
